import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Expand04 = function Expand04(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M20 14v2.8c0 1.1201 0 1.6802-.218 2.108a2 2 0 0 1-.874.874C18.4802 20 17.9201 20 16.8 20H14M10 4H7.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C4 5.5198 4 6.08 4 7.2V10m11-1 6-6m0 0h-6m6 0v6M9 15l-6 6m0 0h6m-6 0v-6"
    })
  }));
};
export default Expand04;